import {useState, useRef } from 'react'

const useError = defaultError => {
  const [error, setError] = useState(defaultError)
  const errorRef = useRef(null);

  const changeError = newError => {
    if (!newError) return setError('');

    setError(newError)
    errorRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  return {
    errorRef,
    error,
    setError: changeError,
  }
}

export default useError